import React from 'react';
import SortableHeaderCell from '../SortableHeaderCell';
import { formatDate } from '../../Utils/dateFormatter';
import { FaSpinner, FaCheckCircle, FaTimesCircle, FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';
import { operationTypeTranslations } from '../../Data/servicesFilters';

const TransactionTable = ({
    transactions,
    loading,
    error,
    ordering,
    onSort,
    onAction, // Function to handle row action
    showProvider = false
}) => {

    if (loading && transactions.length === 0) {
        return (
            <div className="text-center py-10">
                <FaSpinner className="animate-spin text-main1 text-2xl mx-auto mb-4" />
                <p className="text-main1 font-cairo">جاري تحميل البيانات ...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-10 text-red-500 font-cairo">
                {error}
            </div>
        );
    }

    return (
        <div className="overflow-x-auto rounded-2xl shadow-md bg-transparent dir-rtl">
            <table className="min-w-full text-sm text-main1 font-cairo">
                <thead>
                    <tr className="bg-grayish text-main1">

                        <th className="p-4 text-center">رقم العملية</th>
                        <th className="p-4 text-center">
                            <SortableHeaderCell
                                label="التاريخ"
                                field="created_at"
                                ordering={ordering}
                                onSort={onSort}
                                align="center"
                                ascTitle="الأقدم أولاً"
                                descTitle="الأحدث أولاً"
                            />
                        </th>
                        {showProvider && <th className="p-4 text-center">المزود</th>}
                        <th className="p-4 text-center">نوع العملية</th>
                        <th className="p-4 text-center">المستخدم</th>
                        <th className="p-4 text-center">رقم الهاتف</th>
                        <th className="p-4 text-center">المحافظة</th>
                        <th className="p-4 text-center">المستلم</th>
                        <th className="p-4 text-center">
                            <SortableHeaderCell
                                label="المبلغ"
                                field="amount_requested"
                                ordering={ordering}
                                onSort={onSort}
                                align="center"
                            />
                        </th>
                        <th className="p-4 text-center">
                            <SortableHeaderCell
                                label="السعر"
                                field="price"
                                ordering={ordering}
                                onSort={onSort}
                                align="center"
                            />
                        </th>
                        <th className="p-4 text-center">العمولة</th>
                        <th className="p-4 text-center">استجابة API</th>
                        <th className="p-4 text-center">الحالة</th>
                        <th className="p-4 text-right">إجراءات</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.length === 0 ? (
                        <tr>
                            <td colSpan={showProvider ? "10" : "9"} className="text-center py-16">
                                <span className="text-gray-500">لا توجد معاملات</span>
                            </td>
                        </tr>
                    ) : (
                        transactions.map((t, index) => (
                            <tr key={t.id} className="border-b last:border-b-0 hover:bg-grayish/60 transition">
                                <td className="p-4 text-gray-400 text-center">#{t.id}</td>
                                <td className="p-4 text-center text-xs whitespace-pre-line">{formatDate(t.created_at)}</td>
                                {showProvider && (
                                    <td className="p-4 text-center font-bold text-main1">
                                        {t.provider || '-'}
                                    </td>
                                )}
                                <td className="p-4 text-center">{operationTypeTranslations[t.operation_type] || t.operation_type || '-'}</td>
                                <td className="p-4 text-center">{t.user || '-'}</td>
                                <td className="p-4 text-center">{t.user_phone_number || '-'}</td>
                                <td className="p-4 text-center">{t.governorate_name || '-'}</td>
                                <td className="p-4 text-center">{t.recipient_number}</td>
                                <td className="p-4 text-center font-bold">{t.amount_requested}</td>
                                <td className="p-4 text-center">{t.price}</td>
                                <td className="p-4 text-center">{t.commission_amount}</td>
                                <td className="p-4 text-center">
                                    {t.response_data ? (
                                        <div className="group relative flex justify-center">
                                            <FaInfoCircle className="text-main1 cursor-pointer text-lg" />
                                            <div className={`absolute ${index < 2 ? 'top-full mt-2' : 'bottom-full mb-2'} hidden group-hover:block w-72 p-3 bg-gray-800 text-white text-xs rounded shadow-lg z-50 text-right dir-rtl`}>
                                                <div className="border-b border-gray-600 pb-2 mb-2">
                                                    <p><span className="text-gray-400">الحالة:</span> {t.response_data.status || '-'}</p>
                                                    <p><span className="text-gray-400">الرصيد:</span> {t.response_data.balance || '-'}</p>
                                                    <p><span className="text-gray-400">الرسالة:</span> {t.response_data.message || '-'}</p>
                                                </div>
                                                {t.response_data.api_response && (
                                                    <div>
                                                        <p className="font-bold mb-1 text-gray-300">رد المزود:</p>
                                                        <p><span className="text-gray-400">الحالة:</span> {t.response_data.api_response.status || '-'}</p>
                                                        <p><span className="text-gray-400">الرصيد:</span> {t.response_data.api_response.balance || '-'}</p>
                                                        <p><span className="text-gray-400">الرسالة:</span> {t.response_data.api_response.message || '-'}</p>
                                                        <p><span className="text-gray-400">رمزالاستجابة:</span> {t.response_data.api_response._http_status_code || '-'}</p>

                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ) : '-'}
                                </td>
                                <td className="p-4 text-center">
                                    <span className={`px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1 justify-center w-fit mx-auto ${t.api_status === 'success' ? 'bg-green-100 text-green-700' :
                                        t.api_status === 'failed' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'
                                        }`}>
                                        {t.api_status === 'success' ? <FaCheckCircle /> : t.api_status === 'failed' ? <FaTimesCircle /> : <FaExclamationCircle />}
                                        {t.api_status === 'success' ? 'ناجحة' : t.api_status === 'failed' ? 'فاشلة' : t.api_status}
                                    </span>
                                </td>

                                <td className="p-4 text-center">
                                    <button
                                        onClick={() => onAction(t)}
                                        disabled={t.api_status === 'success'}
                                        className={`px-3 py-1 rounded-lg text-xs transition ${t.api_status !== 'success'
                                            ? 'bg-main1 text-white hover:bg-opacity-90 cursor-pointer'
                                            : 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-60'
                                            }`}
                                    >
                                        إعادة معالجة
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TransactionTable;
